
import React from 'react';

function WarningIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={682.667}
            height={682.667}
            viewBox="0 0 512 512"
        >
            <path d="M244 22.7c-10.9 3.9-5.3-5.6-127.8 217.3C54.4 352.5 3.1 446.3 2.2 448.5 1.1 451 .5 455.2.5 460c0 6.2.5 8.5 2.8 13.2 3.5 7.2 11 14.1 18 16.5 5 1.7 15.3 1.8 234.7 1.8 219.4 0 229.7-.1 234.7-1.8 7-2.4 14.5-9.3 18-16.5 2.3-4.7 2.8-7 2.8-13.2 0-4.8-.6-9-1.7-11.5-.9-2.2-52.2-96-114-208.5C272.6 15.9 278.9 26.5 267.6 22.7c-6.2-2.1-17.5-2.1-23.6 0zm25.7 165.4c9.3 4.5 14.6 11.7 16.7 23.1.7 4-19.3 126.3-21.5 131.2-1.4 3-5.5 5.6-8.9 5.6-3.3 0-7.5-2.6-8.8-5.6-1.1-2.3-18.3-101.7-21.2-122-1.6-11.6 2.4-22.9 10.2-28.7 11-8.2 21.5-9.3 33.5-3.6zm-.6 183.7c24.2 11.8 22.6 46.7-2.5 56.1-17.7 6.6-36.7-4.1-40.5-22.9-2.9-14.3 5.5-29.2 19.5-34.5 5.8-2.2 17.7-1.5 23.5 1.3z" />
        </svg>
    );
}

export default WarningIcon;